export const AUTH_SETTINGS = "AUTH_SETTINGS";
export const AUTH_SETTINGS_BY_GROUP = "AUTH_SETTINGS_BY_GROUP";
export const AUTH_SETTINGS_BY_PREMISE = "AUTH_SETTINGS_BY_PREMISE";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export default {
  AUTH_SETTINGS,
  AUTH_SETTINGS_BY_GROUP,
  AUTH_SETTINGS_BY_PREMISE,
  AUTH_LOGIN,
  AUTH_LOGOUT
};
